import React from "react";

// Lazy load product page components
const TermLifeProductPage = React.lazy(() =>
    import("../pages/products/TermLifeProductPage")
);
const MukamalSehatProductPage = React.lazy(() =>
    import("../pages/products/MukamalSehatProductPage")
);
const DreamGoalPage = React.lazy(() =>
    import("../pages/products/DreamGoalPage")
);
const PaymentMethodsPage = React.lazy(() =>
    import("../pages/products/payment-methods/PaymentMethodsPage")
);
const PersonalDetailsPage = React.lazy(() =>
    import("../pages/products/PersonalDetailsPage")
);

// Export route configuration array
export const productRoutes = [
    { path: "/products/term-life-product", element: <TermLifeProductPage /> },
    { path: "/products/mukammal-sehat-product", element: <MukamalSehatProductPage /> },
    { path: "/products/dream-goal", element: <DreamGoalPage /> },
    // { path: "/products/payment-methods", element: <PaymentMethodsPage /> },
    // { path: "/products/personal-details", element: <PersonalDetailsPage /> },
];